import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import { WrappedField } from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderZaiusConfiguration(onChange: (attr: string) => ChangeHandler): JSX.Element {
  return (
    <>
      <CompactSection
        description={`The Gladly-Optimizely integration enables you to segment customers in Optimizely based on whether the customer is engaged in a support conversation in Gladly.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="zaius-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <Row>
          <WrappedField
            attr="connectionSettings.zaiusPublicKey"
            label="Optimizely Tracker ID"
            description="This field is used to determine which Optimizely account to send data"
            data-aid="zaius-public-key"
            onChange={onChange('connectionSettings.zaiusPublicKey')}
          />
        </Row>
      </CompactSection>
    </>
  );
}

export default renderZaiusConfiguration;
